import React, {useContext, useEffect, useState} from 'react';
import ContactForm from "../ContactForm/ContactForm";
import {SellerContext} from "../../context/seller-context";
import SellerCodeReader from "../../utils/SellerCodeReader";
import Validator from "../../utils/Validator";
import analyitics from "../../utils/analytics";
import CallpageManager from "../../utils/CallpageManager";
import phoneIconOrange from "../../assets/images/icons/contact-phone-icon.svg";
import arrowRight from "../../assets/images/icons/arrow_circle_right_white.svg";

function ContactDialog(props) {
    const seller = useContext(SellerContext);
    const sellerCodeReader = new SellerCodeReader();

    const [callPhone, setCallPhone] = useState("");

    useEffect(() => {
        if (Validator.nonNumbersExistsInString(callPhone)) {
            setCallPhone(prev => prev.slice(0, -1));
        }
    }, [callPhone]);

    const handleCallSubmit = (e) => {
        e.preventDefault();
        analyitics.sendEvent({ category: 'Kontakt', action: 'Telefon', label: 'Proszę o kontakt' });
        CallpageManager.performCallOrSchedule(callPhone);
        props.onClose();
    };

    if (!props.isOpen) return null;

    return (
        <div className="contact-dialog-overlay" onClick={props.onClose}>
            <div className="contact-dialog-box" onClick={e => e.stopPropagation()}>

                <button className="contact-dialog-close-btn" onClick={props.onClose}>
                    ×
                </button>

                <h2 className="contact-dialog-title">Skontaktuj się z nami</h2>

                <div className="contact-dialog-cols">

                    {/* ── Lewa kolumna: telefon + callback ── */}
                    <div className="contact-dialog-left">
                        <div className="contact-dialog-phone-section">
                            <p className="contact-dialog-phone-label">
                                Nie chcesz pisać?<br/>Zadzwoń
                            </p>
                            <a href={"tel:" + seller.phone} className="contact-page-contact-link">
                                <img src={phoneIconOrange} alt="" className="contact-page-contact-icon-img"/>
                                <strong>{seller.phone}</strong>
                            </a>
                        </div>

                        <div className="contact-dialog-callback-section">
                            <p className="contact-dialog-callback-title">
                                Chcesz, żebyśmy zadzwonili do Ciebie w 120 sekund?
                            </p>
                            <form onSubmit={handleCallSubmit} className="contact-dialog-callback-form">
                                <div className="contact-form-field">
                                    <label className="contact-form-label">Podaj nr telefonu</label>
                                    <input
                                        className="contact-form-input"
                                        required
                                        type="text"
                                        minLength="9"
                                        maxLength="9"
                                        pattern="[0-9]{9}"
                                        value={callPhone}
                                        onChange={e => setCallPhone(e.target.value)}
                                        placeholder=""
                                    />
                                </div>
                                <button type="submit" className="contact-form-submit">
                                    zadzwońcie teraz
                                    <img src={arrowRight} alt="" className="contact-form-submit-icon"/>
                                </button>
                            </form>
                        </div>
                    </div>

                    {/* ── Prawa kolumna: formularz kontaktowy ── */}
                    <div className="contact-dialog-right">
                        <ContactForm
                            onSuccess={props.onClose}
                            additionalMessage={props.additionalMessage}
                        />
                    </div>

                </div>
            </div>
        </div>
    );
}

export default ContactDialog;
